import React from "react";
import { Card, Select, Button, Table, Tag, Space, Alert, Empty, Spin } from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";

const { Option } = Select;

const DatabricksPanel = ({
  isDark,
  tableScrollY,
  awsAccounts,
  databricksAccounts,
  databricksAccountsLoading,
  selectedDatabricksAccount,
  onSelectDatabricksAccount,
  databricksWorkspaces,
  selectedDatabricksWorkspace,
  onSelectWorkspace,
  databricksPipelines,
  databricksPipelinesLoading,
  onDiscoverPipelines,
  databricksPipelineToggling,
  onTogglePipeline,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
        gap: 16,
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Select
          placeholder={databricksAccountsLoading ? "Loading..." : "Select Databricks Account"}
          value={selectedDatabricksAccount?.account_id}
          onChange={onSelectDatabricksAccount}
          style={{ width: 260 }}
          loading={databricksAccountsLoading}
        >
          {databricksAccounts.map((a) => (
            <Option key={a.account_id} value={a.account_id}>
              {a.account_name || a.account_id || `Account ${a.account_id}`}
            </Option>
          ))}
        </Select>
        <Select
          placeholder="Select Workspace"
          value={
            selectedDatabricksWorkspace?.workspace_name ||
            selectedDatabricksWorkspace?.deployment_name
          }
          onChange={onSelectWorkspace}
          style={{ width: 260 }}
          disabled={!selectedDatabricksAccount}
        >
          {databricksWorkspaces.map((w) => (
            <Option
              key={w.workspace_id || w.workspace_name || w.deployment_name}
              value={w.workspace_name || w.deployment_name}
            >
              {w.workspace_name || w.deployment_name || w.workspace_id}
            </Option>
          ))}
        </Select>
        <Button
          type="primary"
          icon={<ThunderboltOutlined />}
          onClick={onDiscoverPipelines}
          loading={databricksPipelinesLoading}
          disabled={!selectedDatabricksWorkspace || databricksPipelinesLoading}
        >
          Discover Pipelines
        </Button>
      </div>

      <Card
        title={`Databricks Pipelines (${databricksPipelines.length})`}
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
        bodyStyle={{ padding: 0, flex: 1 }}
      >
        <Table
          rowKey={(p) => p.id}
          sticky
          scroll={{ y: tableScrollY }}
          pagination={false}
          loading={databricksPipelinesLoading}
          dataSource={databricksPipelines}
          locale={{
            emptyText:
              !selectedDatabricksAccount && !databricksAccountsLoading ? (
                <Alert
                  message="Select a Databricks account"
                  description="Choose an account and workspace to discover Delta Live Tables pipelines."
                  type="info"
                  showIcon
                />
              ) : selectedDatabricksWorkspace ? (
                databricksPipelinesLoading ? (
                  <Spin />
                ) : (
                  <Empty description="No Databricks pipelines found" />
                )
              ) : (
                <Empty description="Select a workspace to discover pipelines" />
              ),
          }}
          columns={[
            {
              title: "Pipeline",
              dataIndex: "name",
              key: "name",
              render: (_, p) => (
                <div>
                  <div
                    style={{
                      fontWeight: 600,
                      color: isDark ? "#e6edf3" : "#0f172a",
                    }}
                  >
                    {p.name || p.id}
                  </div>
                  {p.workspace_name && (
                    <div
                      style={{
                        fontSize: 12,
                        color: isDark ? "#8b949e" : "#64748b",
                        marginTop: 4,
                      }}
                    >
                      {p.workspace_name}
                    </div>
                  )}
                </div>
              ),
            },
            {
              title: "Status",
              key: "status",
              width: 220,
              render: (_, p) => (
                <Space size={6} wrap>
                  {p.logs_enabled && <Tag color="green">Logs</Tag>}
                  {p.metrics_enabled && <Tag color="blue">Metrics</Tag>}
                  {!p.logs_enabled && !p.metrics_enabled && (
                    <Tag color="default">Not enabled</Tag>
                  )}
                </Space>
              ),
            },
            {
              title: "Actions",
              key: "actions",
              width: 140,
              render: (_, p) => {
                const enabled = p.enabled || p.logs_enabled || p.metrics_enabled;
                return (
                  <Button
                    type={enabled ? "default" : "primary"}
                    size="small"
                    loading={databricksPipelineToggling === p.id}
                    onClick={() => onTogglePipeline(p, !enabled)}
                  >
                    {enabled ? "Disable" : "Enable"}
                  </Button>
                );
              },
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default DatabricksPanel;

